<!--
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-20 16:06:42
 * @Description:
 * @FilePath: \mobile-revive\src\App.vue
-->
<template>
  <div id="app">
    <keep-alive :include="keepAliveList">
      <router-view />
    </keep-alive>
    <Watermark />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Watermark from '@/components/Watermark'
export default {
    name: 'App',
    computed: {
        ...mapState(['transitonName']),
        keepAliveList() {
            return this.$store.state.keepAliveList
        }
    },
    created() {
        console.log(this.$route)
    },
    components: {
        Watermark
    }
}
</script>
<style lang="scss">
@import "~@/assets/font/iconfont.css";
.xh-slide-enter {
  transform: translateX(100%);
  //opacity: 0;
}
.xh-slide-enter-active {
  transition: all 0.4s;
}
.xh-slide-enter-to {
  transform: translateX(0);
  //opacity: 1;
}

.xh-back-enter {
  transform: translateX(-100%);
}
.xh-back-enter-active {
  transition: all 0.4s;
}
.xh-back-enter-to {
  transform: translateX(0);
}
/* .xh-back-leave{
  opacity:1;
}
.xh-back-leave-active{
  transition:all .1s;
}
.xh-back-leave-to{
  opacity: 0;
} */
</style>

